import type { ListRowProps } from "./ListRow";
import { ListRow } from "./ListRow";

/**
 * MediaRow — `ListRow` variant for tracks/playlists (adds the `ds-media-row`
 * modifier). Mirrors `DSMediaRow` on iOS.
 */
export function MediaRow(props: Readonly<ListRowProps>) {
	return (
		<ListRow
			{...props}
			className={`ds-media-row ${props.className ?? ""}`.trim()}
		/>
	);
}
